import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { formShape } from "utils/propTypeShapes"
import { TaskSubformIcon, TaskGeneralIcon } from "shared/icons"
import TruncatedWithTooltip from "shared/TruncatedWithTooltip"

const TaskTokenTitle = ({
  subform = {}, title = "", className = "", formTitleClassName = "", formTitleTruncateAt = undefined,
}) => {
  const isSubform = !!subform
  const formTitle = title?.length ? title : "General Task"
  const Icon = isSubform ? TaskSubformIcon : TaskGeneralIcon
  const displayedTitle = isSubform ? subform.title : formTitle

  return (
    <span className={clsx(className, "text-token min-h-9 font-medium p-1.5")}>
      <Icon className="shrink-0 mr-1.5 h-6 w-6 bg-white" />
      {
        formTitleTruncateAt
          ? <TruncatedWithTooltip className={formTitleClassName} text={displayedTitle} truncateAt={formTitleTruncateAt} />
          : <span className={formTitleClassName}>{displayedTitle}</span>
      }
    </span>
  )
}

TaskTokenTitle.propTypes = {
  className: types.string,
  formTitleClassName: types.string,
  formTitleTruncateAt: TruncatedWithTooltip.propTypes.truncateAt,
  subform: formShape,
  title: types.string,
}

export default TaskTokenTitle
